import type { BonoContent } from '../types/content';

// The 5 bonos included in every version (Base and Kit) — text-only cards.
export const bonos: BonoContent[] = [
  {
    number: '01',
    label: 'BONO 01',
    title: 'FICHAS DE PISTA',
    tag: 'FICHA',
    oneLiner: '25 fichas para consultar el objetivo de la sesión antes de entrar a pista.',
    bullets: ['25 fichas listas para consultar', 'Objetivo y ejercicio en una página', 'Pensadas para leer en 30 segundos'],
    value: '9,90€'
  },
  {
    number: '02',
    label: 'BONO 02',
    title: 'RADAR DEL ALUMNO',
    tag: 'PLANTILLA',
    oneLiner: 'Diagnóstico express en 7 minutos para saber por dónde empezar con cada alumno.',
    bullets: ['Diagnóstico en 7 minutos', 'Detecta prioridades por alumno', 'Sin suposiciones, con datos'],
    value: '7,90€'
  },
  {
    number: '03',
    label: 'BONO 03',
    title: 'SEMÁFORO DE CORRECCIONES RÁPIDAS',
    tag: 'GUÍA RÁPIDA',
    oneLiner: '50 errores comunes con indicaciones concretas para corregirlos en pista.',
    bullets: ['50 errores comunes', 'Indicación concreta para cada uno', 'Corrige sin discursos largos'],
    value: '9,90€'
  },
  {
    number: '04',
    label: 'BONO 04',
    title: 'PLANIFICADOR 30 DÍAS',
    tag: 'PLANIFICADOR',
    oneLiner: 'Tu hoja de ruta para implantar el sistema poco a poco durante el primer mes.',
    bullets: ['Hoja de ruta semana a semana', 'Implementación progresiva', 'Sin saturarte el primer mes'],
    value: '7,90€'
  },
  {
    number: '05',
    label: 'BONO 05',
    title: 'VUELTA A PISTA',
    tag: 'RECURSO DE PISTA',
    oneLiner: 'Guía orientativa para adaptar el entrenamiento ante molestias físicas o una vuelta progresiva.',
    bullets: ['Entrenamiento adaptado', 'Para molestias o pausas', 'Orientativo, no médico'],
    value: '7,90€',
    note: 'Material educativo: no sustituye la valoración de un profesional sanitario.'
  }
];

// Extras exclusive to Maestro en Pista + Kit de Ejecución — icon cards.
export const kitExtras: BonoContent[] = [
  {
    number: '06',
    label: 'EXTRA KIT',
    title: 'EL MAPA DE PISTA',
    tag: 'RECURSO DE PISTA',
    oneLiner: '50 esquemas técnicos para entender un ejercicio o situación de juego de un vistazo. Consulta en 10 segundos sin interrumpir la clase.',
    icon: 'mapaDePista',
    premiumOnly: true
  },
  {
    number: '07',
    label: 'EXTRA KIT',
    title: 'PROGRAMADOR 12 MESES',
    tag: 'PLANIFICADOR',
    oneLiner: 'Tu calendario anual para saber qué trabajar cada semana de la temporada. De septiembre a junio, sin preguntarte qué toca el martes.',
    icon: 'programador12Meses',
    premiumOnly: true
  }
];
